import { render, staticRenderFns } from "./add_agentlist_xx.vue?vue&type=template&id=5fb544d5&scoped=true&"
import script from "./add_agentlist_xx.vue?vue&type=script&lang=js&"
export * from "./add_agentlist_xx.vue?vue&type=script&lang=js&"
import style0 from "./add_agentlist_xx.vue?vue&type=style&index=0&id=5fb544d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb544d5",
  null
  
)

export default component.exports